import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";

const PartnerDetailsFields = ({ formData, handleFormDataChange, statesList, districtList }) => {
    const handleSelectChange = (fieldName) => (event) => {
        handleFormDataChange({
            target: {
                name: fieldName,
                value: event.target.value,
            },
        });
    };

    return (
        <div className="row">
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Name"
                        name="p_name"
                        value={formData.p_name || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 50 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="PAN"
                        name="p_pan_no"
                        value={formData.p_pan_no || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 10 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Phone Number"
                        name="p_mobile"
                        value={formData.p_mobile || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ inputMode: "numeric", maxLength: 10 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Email"
                        name="p_email"
                        type="email"
                        value={formData.p_email || ""}
                        onChange={handleFormDataChange}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Address Line 1"
                        name="p_address_1"
                        value={formData.p_address_1 || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 200 }}
                        multiline
                        minRows={2}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Address Line 2"
                        name="p_address_2"
                        value={formData.p_address_2 || ""}
                        onChange={handleFormDataChange}
                        multiline
                        minRows={2}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <InputLabel id="partner-state-label">State</InputLabel>
                    <Select
                        labelId="partner-state-label"
                        id="p_state_id"
                        name="p_state_id"
                        value={String(formData.p_state_id || "")}
                        label="State"
                        onChange={handleSelectChange("p_state_id")}
                    >
                        <MenuItem value="">--Select State--</MenuItem>
                        {statesList.map((state) => (
                            <MenuItem value={String(state.id)} key={state.id}>
                                {state.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <InputLabel id="partner-district-label">District</InputLabel>
                    <Select
                        labelId="partner-district-label"
                        id="p_district"
                        name="p_district"
                        value={String(formData.p_district || "")}
                        label="District"
                        onChange={handleSelectChange("p_district")}
                        disabled={!formData.p_state_id}
                    >
                        <MenuItem value="">--Select District--</MenuItem>
                        {districtList.map((district) => (
                            <MenuItem value={String(district.id)} key={district.id}>
                                {district.city}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="PIN Code"
                        name="p_pincode"
                        value={formData.p_pincode || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ inputMode: "numeric", maxLength: 6 }}
                    />
                </FormControl>
            </div>
        </div>
    );
};

export default PartnerDetailsFields;